export const experienceData = [
    {
        id: 1,
        company: 'Lotterywest',
        jobtitle: 'React Native Mobile Developer',
        startYear: 'Aug 2022',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Komodo Digital',
        jobtitle: 'Software Engineer',
        startYear: 'Nov 2021',
        endYear: 'Jun 2022'
    },
    {
        id: 3,
        company: 'Active housing by Hallnet',
        jobtitle: 'Software Engineer',
        startYear: 'Mar 2021',
        endYear: 'Nov 2021'
    },
    {
        id: 4,
        company: 'Ingot Portal',
        jobtitle: 'Full Stack Developer',
        startYear: 'Jul 2019',
        endYear: 'Mar 2021'
    },
    {
        id: 5,
        company: 'Rescon Technologies',
        jobtitle: 'Software Tester and Developer',
        startYear: 'May 2018',
        endYear: 'Jun 2018'
    },
    {
        id: 6,
        company: 'Liverpool John Moores University',
        jobtitle: 'Cloud-based Integration Intern',
        startYear: 'Jan 2018',
        endYear: 'Apr 2018'
    },
]
